import { useStore } from "@nanostores/react"

import { useEvent } from "shared/lib/useEvent"

import { BuildingReferenceFilterFormData } from "entities/building-references/types/BuildingReferenceFilterFormData"

import {
  buildingReferenceFilterStore,
  resetFilterState,
  setFilterState,
  updateFilterState
} from "./building-reference-filter-store"

export function useBuildingReferenceFilterStore() {
  const state = useStore(buildingReferenceFilterStore)

  const setFilters = useEvent((newState: BuildingReferenceFilterFormData) => {
    setFilterState(newState)
  })

  const updateFilters = useEvent(
    (updates: Partial<BuildingReferenceFilterFormData>) => {
      updateFilterState(updates)
    }
  )

  const resetFilters = useEvent(() => {
    resetFilterState()
  })

  return {
    filterState: state,
    setFilters,
    updateFilters,
    resetFilters
  }
}
